import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from './firebase';

// Pharmacies don't have push notifications (the dashboard is a plain web
// app with no notification channel set up yet), so admin broadcasts aimed
// at pharmacies land here instead — read when you check in, not pushed to
// you. "Seen" is tracked locally per browser since there's no per-pharmacy
// read-state stored anywhere yet.
export default function AnnouncementsTab({ pharmacyId }) {
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onValue(ref(db, 'broadcasts'), snap => {
      const val = snap.val() || {};
      const forPharmacies = Object.entries(val)
        .map(([id, b]) => ({ id, ...b }))
        .filter(b => b.target === 'all_pharmacies')
        .sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));
      setBroadcasts(forPharmacies);
      setLoading(false);
      const latestId = forPharmacies[0]?.id;
      if (latestId) localStorage.setItem(`announcements_seen_${pharmacyId}`, latestId);
    });
    return () => unsubscribe();
  }, [pharmacyId]);

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontWeight: 700, margin: 0, fontSize: 18 }}>📣 Announcements</h2>
        <p style={{ color: '#888', fontSize: 13, margin: '4px 0 0' }}>Messages from the PharmDev team</p>
      </div>

      {loading ? (
        <p style={{ color: '#888', padding: 20 }}>Loading...</p>
      ) : broadcasts.length === 0 ? (
        <div style={{ backgroundColor: '#FFF', borderRadius: 12, border: '1px solid #E5E7EB', textAlign: 'center', padding: 60 }}>
          <p style={{ fontSize: 40, marginBottom: 12 }}>📣</p>
          <p style={{ fontWeight: 600, color: '#333', margin: '0 0 6px' }}>No announcements yet</p>
          <p style={{ fontSize: 13, color: '#888', margin: 0 }}>Messages from PharmDev will appear here</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {broadcasts.map(b => (
            <div key={b.id} style={{ backgroundColor: '#FFF', borderRadius: 12, padding: 18, border: '1px solid #E5E7EB', borderLeft: '4px solid #7C3AED' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <p style={{ fontWeight: 700, fontSize: 15, margin: 0, color: '#1A1A1A' }}>{b.title}</p>
                <span style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>{new Date(b.sentAt).toLocaleDateString()}</span>
              </div>
              <p style={{ fontSize: 13, color: '#555', margin: 0, lineHeight: 1.6 }}>{b.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
